import jQuery from 'jquery';

import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import {
  gsap
} from 'gsap';


import ScrollToPlugin from 'gsap/ScrollToPlugin';
// import GSDevTools from "gsap/GSDevTools";
// import GSDevTools from 'https://assets.codepen.io/16327/GSDevTools3.min.js';
//'gsap-trial/dist/GSDevTools';


// node_modules/gsap-trial/dist/GSDevTools.js
import {
  NavInit
} from '../../../../includes/header-nav/header-nav';
import {
  closeNavigation,
  scrollToSection
} from '../../../../includes/header-nav/nav-helpers';

import {
  activateGradientLine,
  deActivateGradientLine,
  getSiblingsAbove,
  getSiblingsBelow,
  imageryLoaded,
  orientation,
  removePanelClass,
  triggerMovement
} from '../../utilities/helpers';

import {
  initBlocks
} from '../../modules/blocks/index';

import {
  categoryFilters
} from '../../utilities/categoryFilters';

import {
  initHome
} from './namespaces/page-home';
import {
  clearTransform,
  filterCategoryView,
  filterPostView,
  loadIntro,
  lotieScript,
  scrollBackToTop,
  scrollTopPost,
  updateBackButton,
  updateHeaderStyles
} from './barba-helpers';
import {
  initSingle
} from './namespaces/single-resources';

import {
  initArchive
} from './namespaces/archive-resources';
import {
  initPageAbout
} from './namespaces/page-about';

import {
  initLottie
} from '../../../../includes/lottie/lottie';

function init() {
  /*


  TO DO:

  https://barba.js.org/docs/advanced/strategies/#history-add
  May this resovle some of my issues in the movile - I just need tto updatet the hsotory states:

  While browsing the website, Barba stores useful navigation informations into the history property. You can access those informations at any time in your application.

  history.previous|current
  The most useful are the previous and current history attributes. It allows you to access the page namespace, the window scroll position and the page url. For example, if you want to restore scroll position between pages, have a look at the scroll position recipe.

  */

  gsap.registerPlugin(ScrollToPlugin);



  //debugger
  // gsap.registerPlugin(GSDevTools) 
  let cleanupCurrentUI = null;


  // var $ = $ || jQuery, // added to see solve jquery issue - look to remove jquery dependencie all togher
  var

    body = document.querySelector('body'),
    root = document.querySelector(':root'),
    viewerBg = body.querySelector('#bg-viewer'),
    viewerBg_carousel = viewerBg.querySelector('.bg-viewer__container'),
    viewerBg_details = viewerBg.querySelector('.bg-viewer__details'),
    // gsap timeline declartion 
    tlBarba = gsap.timeline(),
    tlBarbaPause = true, // this will allow me to pause the timeline when needed
    spacerWidth,
    gridMargin, // gridMargin - any of the css grids (margins applied on the out container)
    scrollDuration = 1,
    EaseOption = "power4.inOut",
    Breakpoint = getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/['"]+/g, '').trim(); // Remove quotes and extra whitespace
  // GSDevTools.create({animation: tlBarba});

  barba.hooks.ready((data) => {
    // loading Intro
    loadIntro(body, viewerBg);
    //initiate navigation 
    NavInit();
  }); //barba.hooks.beforeOnce((data) =>

  barba.init({
    // there are some fundamental issues with barba atm - a js error somewhere maybe?
    debug: true,
    timeout: 10000, // review (default is 2000)
    requestError: (trigger, action, url, response) => {
      console.log("requestError", response);
      // go to a custom 404 page if the user click on a link that return a 404 response status
      if (action === 'click' && response.status && response.status === 404) {
        barba.go('/404');
        console.log("404 barba error"); // reivew this and other 404 pages
      }
      //ensure we go to the next page if the click fails - this should really never happend though - review accordingly
      if (action === 'click') {
        // https://github.com/barbajs/barba/issues/475
        barba.force(barba.url.parse(url).path)
        /* stop script execution - https://stackoverflow.com/questions/9298839/is-it-possible-to-stop-javascript-execution */
        thisFunctionDoesNotExistInOrderToStopScriptExecution()
      }
      // prevent Barba from redirecting the user to the requested URL
      // this is equivalent to e.preventDefault() in this context
      return false;
    },
    transitions: [{
        name: 'home-to-single', // this new - complete review all events before. enter etc
        sync: false,
        beforeEnter(data) { // home-to-single
          console.log("beforeEnter home-to-single");

          var
            activePost = body.getAttribute('data-active-post'),
            activeCategory = data.current.container.querySelector("[data-panel-content='resources']").getAttribute('data-category-active'),
            activePanelDom = data.current.container.querySelector("[data-panel-content='resources']"), // this to be ammend for transition - to 100vw review in its entirity 
            currentActiveCategoryDom = data.current.container.querySelector('[data-resource-category="' + activeCategory + '"]'),
            currentActivePostDom = activePanelDom.querySelector('.category__post.post.--active'), // this won't be active untill the below js has run - so we need to wait for that to happen
            gridMargin = data.current.container.querySelector(".grid.side-panel__content-area").offsetLeft, // probably target something more specific - but this will do for now
            // currentActiveCategoryPostDom = data.current.container.querySelector("[data-panel-content='resources']").getAttribute('data-category-active'), // this doesn't exist in home panel don't think?
            currentActiveCategoryDomDescription = activePanelDom.querySelector('.category__description'),
            // activeHeader = data.current.container.querySelector('.archive__header'), // on home page ther is no arhive header?
            activeHeader = activePanelDom.querySelector('.panel__header'), //should be cateogry header
            currentActivePostDomContinueReading = currentActivePostDom.querySelector('a.continue-reading'),
            currentActivePostDomContinueReadingText = currentActivePostDomContinueReading.querySelector('span'),

            // activeNav = data.current.container.querySelector('.archive__nav'), // one home page - there is no arvhei nave
            activeNav = activePanelDom.querySelector('.panel__nav'), // one home page - there is no archive__nav - use       panel__nav
            currentActivePostDomHeader = currentActivePostDom.querySelector('.post__header'),
            currentActivePostDomExcerpt = currentActivePostDom.querySelector('.post__excerpt'),
            currentActivePostDomExcerptPadding = (activeNav.offsetHeight / 4), // refer to css ruls for correct measurements

            nonCurrentActivePostDomAbove = getSiblingsAbove(currentActivePostDom),
            nonCurrentActivePostDomBelow = getSiblingsBelow(currentActivePostDom),
            // containerType = "post-transform",
            // posttransformDom = data.next.container.querySelector('.side-panel__container.--post-transform');

            panelLink = data.current.container.querySelector("[data-panel-content='resources']").querySelector('.panel__link'),
            postExpandToggle = currentActivePostDom.querySelector(".post__link"), // + x icon
            postDate = currentActivePostDom.querySelector('.post__date');


          var spacerWidth = data.current.container.querySelector(".side-panel__spacer").offsetWidth;
          const moveUp = "-100vh"; //reivew this.. postsoffSetValue; //offSetValue; //"-100vh";//"-100vh"; - review this - do we also increase the value
          // so adding anotgher 100vh to ensure it goes further (at the same pace - so will look like they move apart)
          const moveDown = "100vh"; //"100vh";


          // console.log("distanceToScroll", distanceToScroll);
          // spacerWidth = 0; //data.current.container.querySelector(".side-panel__spacer").offsetWidth;
          // console.log("spacerWidth - Would just be 0 - as sliding up from bottom?", spacerWidth);
          //height of post excerpt arhvie itme to be transition into the fulll heigh of the post ; so reveal?e
          // or it slides up from the bottom - so we need to know the height of the post excerpt item?
          console.log("beforeenter home-to-single - tl to start");


          // need to kill the scrolling on the ome - and savour the position value
          if (cleanupCurrentUI) {
            cleanupCurrentUI();
            cleanupCurrentUI = null;
          }

          // console.log("This is breaking point if coming from previous barba namespaces?");

          //review the ways this animates - on entering a single post we want to slide up from the bottom
          //or something like that 
          return tlBarba
            .to(currentActivePostDomContinueReadingText, {
              width: 0,
              opacity: 0,
            }, "0")

            .to(currentActivePostDomContinueReading, {
              columnGap: "0",
            }, "0")
            .set(data.current.container, {
              position: 'relative', // this already relative - don't ammnd the current container?
              // overflow: 'hidden', // review - this breaks the sticky headers!
              // top: 0,
            }, "0")
            // set the main element to fixed; in javascript (or maybe laoding!?)
            .set(data.next.container, {
              position: 'absolute',
              top: 0,
              // overflow: 'hidden', // review - this breaks the sticky headers!
              opacity: 0,
            }, "0")

            .to(activeHeader, {
              "--pseudo-after-color": "#BBBBBB",
              // backgroundColor: "red",
            }, "0")

            .to(currentActivePostDomHeader, {
              // borderBottom: "1px solid #BBBBBB",
              paddingBottom: currentActivePostDomExcerptPadding, // needs to be heaerheith var/ 2

              // marginTop: currentActivePostDomExcerptPadding, // needs to be heaerheith var/ 2
            }, ">0.1") //}

            .to(currentActivePostDomHeader, {
              "--after-opacity": "1",
            }, ">0.1") //}
            // .to(currentActivePostDomExcerpt, {
            //   // borderTop: "1px solid #BBBBBB",
            //   // marginTop: currentActivePostDomExcerptPadding, // needs to be heaerheith var/ 2
            // }, ">0.1") //}, scrollDuration)
            //  .to(currentActivePostDomExcerpt, {
            //              // if we set negative margins on left and right - that might achive the full border - but what's the measure?
            //   marginLeft: (-1 * gridMargin), //review
            //   marginRight: (-1 * gridMargin), // review - some of the tex is ver squares
            //   width: "calc(100% + " + (gridMargin * 2) + "px)", //review
            //   duration:0.1,
            // }, "<")

            .add(function () {
              //  console.log("moveDown", moveDown);
              //  console.log("moveUp", moveUp);
              // make sure the current item is in the correct positions
              scrollTopPost(currentActivePostDom); //linkTarget
              // move posts abovae up
              if (nonCurrentActivePostDomAbove.length > 0) {
                // console.log("nonActivePostDomAbove.length > 0");
                tlBarba.to(nonCurrentActivePostDomAbove, {
                  //  duration: scrollDuration,
                  //  y: moveUp,
                  opacity: 0,
                }); //  "0");

              }
              //move posts below down
              if (nonCurrentActivePostDomBelow.length > 0) {

                // console.log("nonActivePostDomBelow.length > 0");
                tlBarba.to(nonCurrentActivePostDomBelow, {
                  y: moveDown,
                  opacity: 0,
                }); //  "0");

              }
            }, ">") // Ensure this runs after the previous animations        
            .to(activeNav, {
              opacity: 0,
            }, ">0.1")
            .to(postExpandToggle, {
              opacity: 0,
            }, "0.5")
            .to(postDate, {
              marginRight: 0,
            }, ">0.1")
            .to(currentActiveCategoryDomDescription, {
              opacity: 0,
            }, ">0.1")
            .to(panelLink, {
              opacity: 0,
            }, "<0.1")
            .to(currentActivePostDom, {
              borderBottomColor: "transparent",
              borderTopColor: "transparent", // "#BBBBBB", // also set to transparent - because no need to dounle oup on borders
            }, "<0.1")

        },
        enter(data) { // home-to-single
          console.log("enter home-to-single");

          // we need to tak ethe old cotainer - and scroll up to the top so that the excerpt post nave is in teh correct postion for when we've loade dthe next page later down
          var activePost = body.getAttribute('data-active-post'),
            activeCategory = body.getAttribute('data-active-category'), // review and tidy up
            activePanelDom = data.current.container.querySelector("[data-panel-content='resources']"), // this to be ammend for transition - to 100vw review in its entirity 
            sidePanelInner = data.current.container.querySelector(".side-panel__inner"), // there's only one of these I think.
            spacerWidth = data.current.container.querySelector(".side-panel__spacer").offsetWidth,
            // activePanelDom = data.current.container.querySelector("[data-panel-content='resources']"),// this to be ammend for transition - to 100vw review in its entirity 
            currentActivePostDom = activePanelDom.querySelector('.category__post.post.--active'), // this won't be active untill the below js has run - so we need to wait for that to happen
            currentActivePostDomContinueReading = currentActivePostDom.querySelector('a.continue-reading');

          console.log("activePanelDom", activePanelDom);

          // Assuming tlBarba is a GSAP timeline instance
          return tlBarba


            // .set(window, { //revoew - but I thik we need to hav ethis somwehre
            //   scrollTo: {
            //     y: 0,
            //     autoKill: true, // review what this does
            //   },
            //   duration:0,
            // }, "0")
            // when we scroll up here - we alter then bg view scroll postion - meaning; either scroll later - or ensure the viewer dissapears? 
            // .set(activePanelDom, { // this is an internal div - review which div will actually be visbile (there are a lot overflows etc!)
            //   // this width needs to be come releavant to the above?
            //      width: "100%",// "100vw", // if we keep this % - and target the inner pannel?
            //      // x: (- 1* (spacerWidth + 1)),//'100%', // review this exact values - and ensure globally consistent

            //    }, ">")
            // we need to ensrue the reading more icon is gone at this tage
            // .add(function () {
            //   console.log("isses uptill now??");
            // }, "20")

            .to(currentActivePostDomContinueReading, {
              opacity: "0",
            }, ">")
            //  .add(function () {
            //     console.log("wating time I thinik we need to ensure the document is scroll to the top");
            // }, "1")
            .set(sidePanelInner, {
              x: 0
            }) // this should set a starting piont to ensrue smootehr transition
            // this is not fucking smooth1
            .to(sidePanelInner, { // this is an internal div - review which div will actually be visbile (there are a lot overflows etc!)
              //  backgroundColor: "yellow", // WTF  - why is this shti not work!
              // width: "100vw", // if we keep this % - and target the inner pannel?
              x: (-1 * (spacerWidth + 1)),
              duration: "0.2",
            }, ">1")
            // .add(function () {
            //         console.log("panel didn't really transition?");
            //     }, ">")
            //  try target this instead: side-panel__inner
            .to(sidePanelInner, { // this is an internal div - review which div will actually be visbile (there are a lot overflows etc!)
              // background: "yellow",
              width: "100vw", // if we keep this % - and target the inner pannel?
              // x: (- 1* (spacerWidth + 1)),
              duration: "0.2",
            }, ">")
          //this: is a cild of the side panel inner - so we can target this instead
          //   .add(function () {
          //     console.log("20sec wating time I thinik we need to ensure the document is scroll to the top");
          // }, "20")

        },
        afterEnter(data) { //home-to-single
          console.log("afterEnter home-to-single");
          // consideration for back buttons - this could be move into before enter?
          // console.log("data.current.url", data.current.url.href);
          // updateBackButton(data.next.container, data.current.url.href); /// review this!!! not relevean maybe?
          //ebnd this could be moved into before enter?

          return tlBarba
            // .add(() => {
            //   console.log("Timeline started = this is firing");
            // })
            .set(window, { //revoew - but I thik we need to hav ethis somwehre
              scrollTo: {
                y: 0,
                autoKill: true, // review what this does
              },
              duration: 0,
            }, "0")
            // .to(data.current.container, {
            //   // opacity: 0,
            // }, "<") // align with the end of the previous animation
            .to(data.next.container, {
              opacity: 1,
              zIndex: 2,
              // duration: 0.4,
              position: 'relative',
              onComplete: () => {
                console.log("Opacity animation completed!");
                // we need to ensrue certain things have loaded - i.e the js - or ensrue we can't see related content?
              }
            }) // Aligns with the start of the previous animation
            .add(() => {
              console.log("clearTransform firing");
              clearTransform(data.next.container);
              console.log("clearTransform fired");
            }); // Fires slightly after the previous animation

        },
        from: {
          namespace: 'home'
        },
        to: {
          namespace: 'single-resources'
        }
      },
      {
        name: 'home-to-archive', // this would no longer exist - it goes straigh to single
        // saying that we maybe still need to keep this - if people click the resources link
        // I think we copy and paste the archive to single barba code + alter that accordingly - 
        // this means adding another transitions
        sync: false, // https://barba.js.org/docs/advanced/transitions/#Sync-mode
        // setting this to false should allow me more control over the transition
        beforeEnter(data) {
          console.log("beforeEnter - home-to-archive");
          //chekc if there was a resource post active? here? - then apply the filter on thepost transform dom?
          var activePost = body.getAttribute('data-active-post'),
            activeCategory = data.current.container.querySelector("[data-panel-content='resources']").getAttribute('data-category-active'), //
            containerType = "post-transform", // this is being applied on the post transform - on the next container
            sidePanelInner = data.current.container.querySelector(".side-panel__inner"), // there's only one of these I think.
            activePanelDom = data.current.container.querySelector("[data-panel-content='resources']"), // this to be ammend for transition - to 100vw review in its entirity 
            activeHeader = activePanelDom.querySelector('.panel__header'); //should be cateogry header

          console.log("HERE - body", body);
          console.log("activePost", activePost);
          console.log("activeCategory", activeCategory);

          if (activePost) {
            //reovew this - but into barba timeline?
            // console.log("YES - IF activePost", activePost);
            filterPostView(activePost, containerType, data.next.container, "home");
          } else if (activeCategory) {
            //has active category selected (but not post beig clicked - so just filter the category)
            //  console.log("has active category selected:",activeCategory);
            filterCategoryView(activeCategory, containerType, data.next.container, "home"); // review this function -write it
          } else {
            // remove this if statement.
            // console.log("no activePost - - what else can this be - review and delete if statemenbt else?");
            // ccould be just clicked on the resources button (no filtering)
          }
          //end filter next container
          console.log("do we reach this?");
          var sidePanelState = data.current.container.querySelector(".side-panel").getAttribute('data-side-panel-state');
          // console.log("sidePanelState", sidePanelState);

          if (sidePanelState == "open") {
            // side panel is open 
            console.log("beforeEnter - side panel is open");
            // const existingWidth = sidePanelInner.offsetWidth; // Get the current width of the element
            // const newWidth = existingWidth + spacerWidth; // Add spacerWidth to the current width

            //   // get width of spacer & update variable accrodingly
            var spacerWidth = data.current.container.querySelector(".side-panel__spacer").offsetWidth;
            console.log("spacerWidth", spacerWidth);

            return tlBarba
              .set(data.next.container, {
                opacity: 0,
                zIndex: 1,
                x: '100%',
              })
              .set(sidePanelInner, {
                x: 0
              })
              .to(activeHeader, {
                "--pseudo-after-color": "#BBBBBB",
                // backgroundColor: "red",
              }, "0")
              .to(sidePanelInner, {
                x: (-1 * (spacerWidth + 1)),
                duration: 1,
              }, ">1")
              .to(sidePanelInner, { // this is an internal div - review which div will actually be visbile (there are a lot overflows etc!)
                //  width: "100vw", // if we keep this % - and target the inner pannel?
                width: () => `${sidePanelInner.offsetWidth + spacerWidth}px`, // Dynamically calculate width
                duration: 1,
              }, ">")
              .fromTo(data.next.container, {
                // opacity: 0,
                position: 'absolute', //review
                top: 0, //review
                x: '100%', // review this exact values - and ensure globally consistent     
              }, {

                x: spacerWidth, // review this exact values - and ensure globally consistent
              }) // ensure the least amount of time needd for this
            //  .add(function () {
            //   console.log("review the spaer width- from 100%");
            // // }, "20")
            // .add(function () {
            //   console.log("enter - home-to-archive - just waited 20s - home-to-archive");
            // }, "40")

          } else if (sidePanelState == "closed" || sidePanelState == "idle") {
            console.log("whole area of transitions to be considered here still - when side panel is closed and going between pages!!!")
          }

        },
        enter(data) { //home-to-archive
          console.log("enter - home-to-archive");
          var sidePanelState = data.current.container.querySelector(".side-panel").getAttribute('data-side-panel-state'),
            activePostId = body.getAttribute('data-active-post'),
            posttransformDom = data.next.container.querySelector('.side-panel__container.--post-transform'),
            // activePostLink = data.next.container.querySelector('li[data-post-id="' + activePost + '"]'),
            postDates = data.next.container.querySelectorAll('.--post-transform .post__date'),
            postLinks = data.next.container.querySelectorAll('.--post-transform .post__link'),
            posttransformDomPanelheader = posttransformDom.querySelector('.panel__header'),
            posttransformDomPanelnav = posttransformDom.querySelector('.panel__nav'),

            posts = data.next.container.querySelectorAll('.--post-transform li.post'), //  console.log("HERE: activePostId", activePostId);
            posttransformDomPanelheaderReadMore = data.next.container.querySelector('.--post-transform .panel__link'),
            activePost = data.next.container.querySelector('.--post-transform li[data-post-id="' + activePostId + '"]');

          // get width of spacer & update variable accrodingly
          var spacerWidth = data.current.container.querySelector(".side-panel__spacer").offsetWidth;

          if (sidePanelState == "open") {
            //side panel is open 

            return tlBarba

              // .set(data.next.container, {
              //   background: 'white',
              //   opacity: 1
              // })
              //            .add(function () {
              // console.log("enter - home-to-archive - just waited 20s - home-to-archive"); 
              // }, "40")
              .add(function () {
                activePost.classList.add('--active');
                // activePost.style.borderTop = '1px solid transparent'; // review
              }, "0")
              .to(data.next.container, {
                // opacity: 0,
                duration: scrollDuration,
                // background: 'white', // this actually covers a table container of sorts (research if needed whic one)_ - so apply  white?!
                x: '0%' // review this exact values - and ensure globally consistent
              }, scrollDuration)

              .to(posttransformDomPanelheader, {
                width: "100vw", // review
                // background: 'red',
                duration: scrollDuration,
                // border: '1px solid red' // temp
              }, scrollDuration)
              .to(posttransformDomPanelnav, {
                width: "100vw", // review
                // background: 'red',
                duration: scrollDuration,
                // border: '1px solid red' // temp
              }, scrollDuration)
              .to(posttransformDomPanelheaderReadMore, {
                // background: 'red',
                display: 'none'
              }, scrollDuration)
              // .set(posts, {
              //   //   // opacity: 0,
              //   // background: 'green'
              //   // width: "100vw", // I believe this fucks up the typography.
              //   // borderBottom: '1px solid transparent', // review
              // }, "0")
              .to(postDates, {
                x: (spacerWidth),
                opacity: 0, // review - just trying out some stuff
              }, scrollDuration)
            // .add(function () {
            //   console.log("just waited 20s - home-to-archive"); 
            //   }, "20")

          } else if (sidePanelState == "closed" || sidePanelState == "idle") {
            // review this once I nail ethe above  
            // if side panel is closed - then the users can be clicking from the navigation menu
            // so we don't really need to concern oursselves with the current panel - but slide in the next one;
            // no filtering of post content required - as the user is not clicking on a post
            console.log("whole area of transitions to be considered here still - when side panel is closed and going between pages!!!")

          }
        },
        afterEnter(data) {
          console.log("afterEnter - home-to-archive");

          // consideration for back buttons - this could be move into before enter?
          // console.log("data.current.url", data.current.url.href);
          // updateBackButton(data.next.container, data.current.url.href); - not need anymore delete comments etc
          //ebnd this could be moved into before enter?

          var sidePanelState = data.current.container.querySelector(".side-panel").getAttribute('data-side-panel-state');
          // console.log("sidePanelState", sidePanelState);
          // get width of spacer & update variable accrodingly
          var spacerWidth = data.current.container.querySelector(".side-panel__spacer").offsetWidth;


          if (sidePanelState == "open") {
            //side panel is open 

            return tlBarba.to(data.current.container, {
                opacity: 0.1,
                position: 'absolute', //review
                top: 0, //review
                // x: '-26.6%' // review this exact values - and ensure globally consistent
                // x: (-1 * spacerWidth), // review this exact values - and ensure globally consistent

              }, ">")
              .to(data.next.container, {
                position: 'relative', //review
                opacity: 1,
              }, ">")
              .add(function () {
                console.log("clearTransform(data.next.container) - home-to-archive");
                clearTransform(data.next.container) // clear transform rules

              })

          } else if (sidePanelState == "closed" || sidePanelState == "idle") {
            // review this once I nail ethe above 
            console.log("whole area of transitions to be considered here still - when side panel is closed and going between pages!!!")
          }


        },
        from: {
          namespace: 'home'
        },
        to: {
          namespace: 'archive-resources'
        }
      }, {
        name: 'home-to-about-page',
        sync: false,
        beforeEnter(data) {
          console.log("beforeEnter - home-to-about-page");

          var sidePanelState = data.current.container.querySelector(".side-panel").getAttribute('data-side-panel-state'),
            posttransformDom = data.next.container.querySelector('.side-panel__container.--post-transform'),
            sidePanelAboutText = data.current.container.querySelector('[data-panel-content="about"] .panel__text'),
            sidePanelAboutImage = data.current.container.querySelector('[data-panel-content="about"] .panel__body-image');


          console.log("sidePanelState", sidePanelState);

          if (sidePanelState == "open") {
            //side panel is open 
            console.log("beforeEnter - side panel is open");

            // get width of spacer & update variable
            spacerWidth = data.current.container.querySelector(".side-panel__spacer").offsetWidth;

            console.log("spacerWidth - side panel is open", spacerWidth);

            return tlBarba.fromTo(data.next.container, {
                opacity: 0,
                position: 'absolute', //review
                top: 0, //review
                x: '100%' // review this exact values - and ensure globally consistent

              }, {
                // x: '26.6%', //TO DO: need a better solution for this - review!!!
                /* the value could be derived from the grid classes. But:
                - column counts changes across breakpoints
                */
                x: spacerWidth, // review this exact values - and ensure globally consistent
              }, ">") // review this timing
              .to(data.next.container, {
                zIndex: 2, // // review value
              }, ">")
              .to(data.current.container, {
                //if the z-index of the other item is set to initial it will be abve this one.

                zIndex: 1, // // review value
              }, ">")
            // .add(function () {
            //   console.log("wait hERE  for 20 sec");
            // },"<20")


          } else if (sidePanelState == "closed" || sidePanelState == "idle") {
            console.log("whole area of transitions to be considered here still - when side panel is closed and going between pages!!!")

          }

        },
        enter(data) {
          console.log("enter - home-to-about-page");
          var sidePanelState = data.current.container.querySelector(".side-panel").getAttribute('data-side-panel-state'),
            posttransformDom = data.next.container.querySelector('.side-panel__container.--post-transform'),


            //pre transform dom - ie.ecurrent side panel
            sidePanelAboutText = data.current.container.querySelector('[data-panel-content="about"] .panel__text'),
            sidePanelAboutImage = data.current.container.querySelector('[data-panel-content="about"] .panel__body-image'),

            // post transform dom -i.e next side panel
            posttransformDomText = posttransformDom.querySelector('.panel__body-description'),
            posttransformDomImage = posttransformDom.querySelector('.panel__body-image'),
            posttransformDomImageBg = posttransformDomImage.querySelector('.bg__image'),
            // posttransformDomPanelheaderLine = posttransformDom.querySelector('.panel__header:after'), // can\t access this with js 
            posttransformDomPanelheader = posttransformDom.querySelector('.panel__header'), // try jst making the header bigger?
            posttransformDomPanelheaderTitle = posttransformDomPanelheader.querySelector('.panel__header-title'), // try jst making the header bigger?
            posttransformDomPanelheaderTitleBounds = posttransformDomPanelheaderTitle.getBoundingClientRect(),

            posttransformDomPanelheaderReadMore = posttransformDomPanelheader.querySelector('.panel__link'), // try jst making the header bigger?

            sidePanelAboutTextBounds = posttransformDomText.getBoundingClientRect(); // post transform dom

          // console.log("sidePanelAboutText", sidePanelAboutText);
          // console.log("sidePanelAboutTextBounds", sidePanelAboutTextBounds);

          // console.log("posttransformDomPanelheaderLine", posttransformDomPanelheaderLine);
          console.log("  posttransformDomPanelheader", posttransformDomPanelheader);
          var nextArticleDomImage = data.next.container.querySelector('.article__content #about-intro-image'),
            nextArticleDomText = data.next.container.querySelector('.article__content #about-intro-text'),
            // nextArticleDomTextArea = data.next.container.querySelector('.article__content #about-intro-text'),
            imageBounds = nextArticleDomImage.getBoundingClientRect(),
            textBounds = nextArticleDomText.getBoundingClientRect(),
            // textAreaBounds = nextArticleDomTextArea .getBoundingClientRect();
            nextArticleNav = data.next.container.querySelector('.page__nav').getBoundingClientRect(),

            //update the gridMargin variable

            gridMargin = data.current.container.querySelector(".grid.side-panel__content-area").offsetLeft, // probably target something more specific - but this will do for now

            // console.log("textBounds", sidePanelAboutText);
            // console.log("gridMargin", gridMargin);
            // posttransformDomTextHeight = sidePanelAboutTextBounds.height;
            // posttransformDommarginTop = 

            appliedMarginTopImage,
            appliedMarginTopText,
            appliedColor,
            appliedDescriptionHeight,
            appliedDescriptionWidth,
            appliedImageHeight;

          // console.log("gridMargin", gridMargin);

          // // console.log("Breakpoint", Breakpoint);
          console.log("textBounds", textBounds);
          console.log("textBounds height:", textBounds.height);
          // console.log("textBounds width:", textBounds.width);
          console.log("textBounds offsetTop:", textBounds.top); // is about 500 shoudl be abut 300

          // console.log("Breakpoint", Breakpoint);

          // TO DOD - ensure this breakpoint works - its not have created atm - 23rd oct- continue on the 24

          if (Breakpoint === "md" || Breakpoint === "lg" || Breakpoint === "xl") {
            console.log("Breakpoint - 1st condition", Breakpoint);
            // review this - it's not working
            appliedMarginTopText = ((textBounds.top) - (posttransformDomPanelheader.getBoundingClientRect().height * 2)) + "px"; //  (posttransformDomPanelheader.getBoundingClientRect().height * 1) + "px"; // "calc(var(--header-height)*3)";
            // needed to move up about 140px  - so alter this - review the logic of the calculation
            appliedMarginTopImage = (-1 * ((textBounds.height))) + "px"; // this too much = approx 130?

            // appliedMarginTopImage = (-1 * ((textBounds.height) - (posttransformDomPanelheader.getBoundingClientRect().height * 1))) + "px"; // this too much = approx 130?
            appliedDescriptionWidth = textBounds.width + "px";
            appliedDescriptionHeight = "20%"; //"auto - that doesn't retain the 20%";//this is set to 20% - which we want to keep // "calc(100vh - var(--header-height))"; // don't think this is possible maybe if I assign it as a css rull - better to use documen values--//this needs to be like 100vh - all teh  navs
            appliedImageHeight = imageBounds.height; // "calc(100vh - var(--header-height))"; // review this
            appliedColor = "transparent";

          } else if (Breakpoint === "base" || Breakpoint === "xs" || Breakpoint === "xxs" || Breakpoint === "sm") {
            console.log("Breakpoint - 2nd condition", Breakpoint);
            appliedMarginTopText = (posttransformDomPanelheader.getBoundingClientRect().height * 1) + "px"; // "calc(var(--header-height)*3)";
            // appliedMarginTopText =  "calc(var(--header-height)*3)"; // review this - just a wild guess atm
            appliedMarginTopImage = (posttransformDomPanelheader.getBoundingClientRect().height * 1) + "px"; //(-1 * sidePanelAboutTextBounds.height) + 'px';; //actually setiting y value instead- not margin - review this values - what should it be? - not moving at all?
            appliedDescriptionHeight = (1 * textBounds.height) + "px"; //"20%";// "calc(65vh - var(--header-height))";
            appliedDescriptionWidth = textBounds.width + "px"; //review currentluy this does exhibits issues so setting this may.
            appliedImageHeight = imageBounds.height; //"calc(35vh - var(--header-height))";
            appliedColor = "transparent"; // This was showing - can't have it live!"yellow";
          }

          // console.log("AppliedMarginTopText", appliedMarginTopText);
          console.log("appliedMarginTopImage", appliedMarginTopImage);
          // console.log("appliedColor", appliedColor);


          // console.log("imageBounds", imageBounds);
          // console.log("imageBounds.width", imageBounds.width);
          // console.log("imageBounds.left", imageBounds.left);
          // console.log("imageBounds.top", imageBounds.top);
          // console.log("imageBounds.height", imageBounds.height);


          // console.log("imageBounds.height", imageBounds.height);

          // console.log("spacerWidth", spacerWidth);
          // console.log("gridMargin", gridMargin);


          if (sidePanelState == "open") {
            //side panel is open 

            console.log("posttransformDomPanelheaderTitleBounds.width", posttransformDomPanelheaderTitleBounds.width)

            return tlBarba.to(data.next.container, {
                opacity: 1,
              }, ">") // review this timing
              .to(data.next.container, {
                x: '0%'
              }, ">")
              .to(posttransformDomPanelheader, {
                width: "100vw",
              }, "<")

              .to(posttransformDomPanelheaderReadMore, {
                display: 'none' // review this - use transition based css rules
              }, "<")
              .to(posttransformDomImage, {
                // do I just reaplace the values set to image with the ones set to text - i.e the size; translate etc.
                x: ((imageBounds.left - spacerWidth) - gridMargin),

              }, "<")
              .to(posttransformDomImage, {
                y: appliedMarginTopImage,
                width: imageBounds.width,
                height: appliedImageHeight, //imageBounds.height,//imageBounds.height, // this still correct? - but are. we setting this to 100vh in css?
                duration: scrollDuration,

              }, ">1") // review this timing
              .to(posttransformDomText, {

                height: appliedDescriptionHeight, //nextArticleDomText.height,//textBounds.height,
                // need to move down the text by the height of the navs
                background: appliedColor,
                y: appliedMarginTopText, //review - top would require absolute - 
                // do we need to set width - the text is not the same as the resulting page atm - to many rules resizing things maybe?

                // margin: calc(35vh - var(--header-height)) 0 auto 0; // this being applied in css
                // this is set to early?
                // y: "35vh", // review this - just a wild guess atm" // review this exact values - and ensure globally consistent
                // this okay but we need to also consier the nav height - which we've removed from the css (in about intro)
                //  background:"grey",
                // duration: scrollDuration,
              }, "<1") // setting at 2 works well in the first instance - after that it overlaps afgain!?
              // this suggest other css values set by gsap maybe the issue - but what!? position of cotainers maybe
              //panel header title - move 50% into thecenter
              .to(posttransformDomPanelheaderTitle, {
                // justifyContent: "center", // review - maybe require some maths
                x: "50%", // this correct?// no - ensure 
                // position: "absolute",
                // left: (posttransformDomPanelheaderTitleBounds.width/2), //
                // (posttransformDomPanelheaderTitleBounds.width/2)
              }, "=")
              .to(posttransformDomPanelheaderTitle, {
                opacity: 0,
              }, "=")

          } else if (sidePanelState == "closed" || sidePanelState == "idle") {
            // review this once I nail ethe above 
            console.log("whole area of transitions to be considered here still - when side panel is closed and going between pages!!!")

          }
        },
        afterEnter(data) {
          console.log("afterEnter - home-to-about--page");

          //review if we want ta back button (see resources barba afterEnter)
          // updateBackButton(data.next.container, data.current.url.href);

          var sidePanelState = data.current.container.querySelector(".side-panel").getAttribute('data-side-panel-state');
          console.log("sidePanelState", sidePanelState);


          if (sidePanelState == "open") {
            //side panel is open 

            return tlBarba.to(data.current.container, {
                opacity: 0,
                position: 'absolute', //review
                top: 0, //review
                // x: '-26.6%' // review this exact values - and ensure globally consistent
                x: (-1 * spacerWidth), // review this exact values - and ensure globally consistent

              }, ">").to(data.next.container, {
                position: 'relative', //review
              }, ">")
              .add(function () {
                console.log("clearTransform(data.next.container) - home-to-about __5 - this works right");
                clearTransform(data.next.container) // clear transform rules


              });

          } else if (sidePanelState == "closed" || sidePanelState == "idle") {
            // review this once I nail ethe above 
            console.log("whole area of transitions to be considered here still - when side panel is closed and going between pages!!!")
          }

        },
        from: {
          namespace: 'home'
        },
        to: {
          namespace: 'page-about'
        }
      }, {
        name: 'to-home',
        sync: false,
        beforeEnter(data) {
          console.log("leave to-home");


          let gradientLineContainer = document.querySelector('.line-container');
          let gradientLine = gradientLineContainer.querySelector('.line');
          let linkTarget = "home";


          data.current.container.style.position = 'absolute';
          data.current.container.style.top = 0;
          data.current.container.style.left = 0;
          data.current.container.style.width = '100%';
          data.current.container.style.zIndex = '23'; //need to ensure above next
          // data.next.container.style.opacity = '1';

          // atm when we click on home from archive ; use case
          /*
          something shifts to the top - revealing the descript. Basically - nothing should be shifting away from current scroll possitions
          // it maybe be because both containters set at absolute ? and/or height auto maybe?


          // atm single to - home - I don't see thatblue line when it slides to the right- on the lft
          */

          if (data.current.namespace == 'page-about') { // revioew what else needs to be red
            var containerLineColor = "#9f2724"; // rview this code approach
            var lineState = "about"; // rview this code approach
            // } else if (data.current.namespace == 'single-resources') {
            // } else if (data.current.namespace == 'page') {
          } else {
            var lineState = "resources"; // associated with the default color:

            var containerLineColor = "#484AD8"; // rview this code approach
          }


          return tlBarba.to(data.next.container, {
              // opacity: 0,
              // position: 'absolute', //ensure its already in the right position
              // but if the other is absolute then  we have an issue?
              position: 'relative', //ensure its already in the right position
              top: 0,
              zIndex: '10', //below current containers
            })
            .set(data.current.container, {
              borderLeft: '1px solid ' + containerLineColor,
              // borderLeftColor: containerLineColor,
            }) // review this timing
            .add(function () {
              console.log("ensure line is the same color as where weve come frome", lineState);
              gradientLine.setAttribute('data-gradient-state', lineState);
              activateGradientLine(gradientLine); // ensure line is set to idle

            })
          //review setting the   gradientLine.setAttribute('data-gradient-state', linkTarget);


          // .add(function () {
          //   console.log(" has teh container been set tht color? - also check the css to ensrue it feasviblely set up");
          // }, '20')
          // .add(function () {
          //   console.log("before enter finished -to-home");
          // }, '10')

        },
        enter(data) {
          console.log("enter to-home");

          // we need to see if ther was a previous home scroll position
          // if so - ensure to scroll to that bbefore the view sees teh ome page
          let gradientLineContainer = document.querySelector('.line-container');
          let gradientLine = gradientLineContainer.querySelector('.line');


          return tlBarba.set(data.next.container, {
              // duration: scrollDuration,
              // x: '-100%', // this was commented out - but I think it's needed?
              // zIndex: '2' // back to default?
            })


            .fromTo(data.current.container, {
              // opacity: 0,
              x: '0%',
            }, {
              x: '100%',
              duration: scrollDuration,
            }, '<') // review this timing


        },
        afterEnter(data) {
          console.log("afterEnter 'to-home' ['archive-resources', 'single-resources', 'page'] to home");

          let gradientLineContainer = document.querySelector('.line-container');
          let gradientLine = gradientLineContainer.querySelector('.line');



          return tlBarba
            .to(data.next.container, {
              // opacity: 0,
              position: 'relative', //ensure its already in the right position
              // top: 0,
              zIndex: 'initial', //below current containers
            })

            .add(function () {
              clearTransform(data.next.container) // clear transform rules
            })
            .add(function () {
              console.log("// ensure line is set to idle etc"); //
              // clearTransform(data.next.container) // clear transform rules
              deActivateGradientLine(gradientLine); // ensure line is set to idle  
            })
          // .add(function () {
          //   console.log(" after finished -to-home");
          // }, '10')
        },
        from: {
          namespace: ['archive-resources', 'single-resources', 'page-about', 'page'] // page - such as 404 or somethign - check this! ensrue we cover all eventuallity (and have crorrect line colur)
        },
        to: {
          namespace: 'home'
        }
      }, {
        name: 'about-to-archive', // beforeenter: about to resources
        sync: false,
        beforeEnter(data) { //  beforeenter: about to resources
          console.log("beforeEnter about-to-archive and single");
          // console.log("revewi what's happend with tlBarba here", tlBarba.totalProgress());
          var
            posttransformDom = data.next.container.querySelector('.side-panel__container.--post-transform'),
            articleContent = data.next.container.querySelector('.article__content');


          data.current.container.style.position = 'absolute';
          data.current.container.style.left = 0;
          data.current.container.style.width = '100%';
          data.current.container.style.zIndex = '23';
          data.current.container.style.height = '100vh'; //review

          posttransformDom.style.display = 'none'; // 

          // data.current.container.style.backgroundColor = 'purple';
          // data.current.container.style.overflow = 'hidden'; //review
          // // data.next.container.style.opacity = '1';
          data.current.container.querySelector('.page__header').style.top = '0'; // this corec?


          console.log("posttransformDom", posttransformDom, "apply lottie");

          // initLottie(posttransformDom);//container);

          return tlBarba
            .set(data.next.container, {
              opacity: 1,
              // position: 'absolute', //ensure its already in the right position
              x: '-100%', //
              position: 'relative', //ensure its already in the right position
              top: 0,
              zIndex: '10', //below current containers
            })
            .set(articleContent, {
              opacity: 1,
            })

        },
        enter(data) { // enter about to rsource
          console.log("enter about-to-archive and about-to-single");



          var posttransformDom = data.next.container.querySelector('.side-panel__container.--post-transform');



          return tlBarba
            .add(function () {
              // console.log("hello does this fire?,  posttransformDom ", posttransformDom ); // this is not firing at all1? why not
              //review this after OI've sorted the other waay: archive-to-about
              // what abotu all the other rules; i.e scale translate etc
            }, "<");
          // .to(data.next.container, {
          //   x: '0%',
          //   duration: scrollDuration,
          // }, scrollDuration)
          // .fromTo(data.current.container, {
          //   // opacity: 0,
          //   x: '0%',
          // }, {
          //   x: '100%',
          //   duration: scrollDuration,
          // }, '<') // review this timing // // review this timing

        },
        afterEnter(data) { // after enter about to resources : archive and single
          console.log("afterEnter about-to-archive and about-to-single");
          // review - I haven't chekc what about to single looks like because this link doesn't really exist yet

          // data.current.container.style.position = 'absolute';
          return tlBarba
            .to(data.next.container, {
              x: '0%',
              duration: scrollDuration,
            }, scrollDuration)
            .fromTo(data.current.container, {
              // opacity: 0,
              x: '0%',
            }, {
              x: '100%',
              duration: scrollDuration,
            }, '<') // review this timing // // review this timing
            .set(data.next.container, {
              position: 'relative', //ensure its already in the right position
              zIndex: 'initial', //below current containers
              // duration: scrollDuration,
              // add more rules in here?
            }, "0")
            .add(function () {
              console.log("why is not running?"); // this is not firing at all1? why not
              //review this after OI've sorted the other waay: archive-to-about
              // what abotu all the other rules; i.e scale translate etc
            }, "<");

        },
        from: {
          namespace: 'page-about'
        },
        to: {
          namespace: ['archive-resources', 'single-resources']

        }
      },
      {
        name: 'archive-to-about',
        sync: false,
        beforeEnter(data) { //'archive-to-about -also single resources to about'
          // console.log("beforeEnter  archive-to-about +  single resources to about");
          // this seem sto hang?!



          var posttransformDom = data.next.container.querySelector('.side-panel__container.--post-transform'),
            articleContent = data.next.container.querySelector('.article__content');


          // console.log("articleContent", articleContent);
          // console.log("posttransformDom", posttransformDom);

          //  console.log("data.current.namespace = ", data.current.namespace);

          data.current.container.style.position = 'absolute'; // was absolute
          // data.current.container.style.top = 0;
          data.current.container.style.left = 0;
          data.current.container.style.width = '100%';
          data.current.container.style.zIndex = '23';
          data.current.container.style.height = '100vh'; //review 
          posttransformDom.style.display = 'none'; // 

          // data.next.container.style.opacity = '0'; // review this - it's not being reset on the single page


          // data.next.container.style.position = 'absolute'; // was absolute

          if (data.current.namespace == 'archive-resources') {
            // console.log("archive-to-about");
            data.current.container.querySelector('.archive__header').style.top = '0'; // review this - it's not being reset on the single page

          } else if (data.current.namespace == 'single-resources') {
            // console.log("single-to-about");
            data.current.container.querySelector('.single__header').style.top = '0'; // review this - it's not being reset on the single page
          }

          // console.log("beforeEnter returning barba timelines");

          return tlBarba.set(data.next.container, {
              opacity: 1,
              // position: 'absolute', //ensure its already in the right position
              x: '100%', //
              position: 'relative', //ensure its already in the right position
              top: 0,
              zIndex: '10', //below current containers
            })
            .set(articleContent, {
              opacity: 1,
            }) // review this timing

        },
        enter(data) {
          console.log("enter  archive-to-about +  single resources to about");
          console.log("before we start the tlbarba - things start breaking here?");
          console.log("scrollDuration", scrollDuration);

          return tlBarba
            // .to(articleContent, {
            //   opacity: 1,
            //   duration: scrollDuration,
            // }, scrollDuration) //// review this timing
            // .to(posttransformDom, {
            //   opacity: 0,
            //   duration: scrollDuration,
            // }, scrollDuration) // review this timing
            // .to(data.next.container, {
            //   opacity: 1,
            //   duration: scrollDuration,
            // }, scrollDuration)
            .to(data.next.container, {
              x: '0%',
              duration: scrollDuration,
            }, scrollDuration)
            .fromTo(data.current.container, {
              // opacity: 0,
              x: '0%',
            }, {
              x: '-100%',
              duration: scrollDuration,
            }, '<') // review this timing // // review this timing
          // .add(function () {
          //   console.log("add function - what the fuck is going on here?");
          // }, "10");

        },
        afterEnter(data) {
          console.log("afterEnter  archive-to-about +  single-to-about", tlBarba); // but this isn't logged!?> what the fuck1?
          // but this console log is - meaning 
          // data.current.container.style.position = 'absolute';
          // console.log("we don't reach this?!",data);

          return tlBarba
            .add(function () {
              console.log("this never fires?!"); // this is not firing at all1? why not
              // reivew requirements fo rthe line?
              // console.log("clearTransform(data.next.container) - about to archive -  is error caused?");
              //  clearTransform(data.next.container) // clear transform rules
              //  data.next.container.removeAttr( 'style' ); // review maybe works?

              // what abotu all the other rules; i.e scale translate etc
            })
            .set(data.next.container, {
              // position: 'relative', //ensure its already in the right position
              // zIndex: 'initial', //below current containers
              // duration: scrollDuration,
              // add more rules in here?
            }, "0")


        },
        from: {
          namespace: ['archive-resources', 'single-resources']
        },
        to: {
          namespace: 'page-about'
        }
      },
      {
        name: 'single-to-archive',
        sync: false,
        beforeEnter(data) {
          console.log("beforeEnter single-to-archive");

          var posttransformDom = data.next.container.querySelector('.side-panel__container.--post-transform');


          // I rtihnk we need to just look at hiding the sidepanel  (opacity) - immediately - its not really used I tink!?
          //try and review this approach

          console.log("posttransformDom", posttransformDom);


          data.current.container.style.position = 'absolute';
          data.current.container.style.top = 0;
          data.current.container.style.left = 0;
          data.current.container.style.width = '100%';

          if (posttransformDom) {
            posttransformDom.style.opacity = 0; //review this  -      //try and review this approach
          }

          return tlBarba
            .set(data.next.container, {
              opacity: 0,
              // x: '100%',
            }, 1) // review this timing

        },
        enter(data) {
          console.log("enter single-to-archive");


          return tlBarba
            .to(data.next.container, {
              opacity: 1,
            }, "1"); // review this timing

        },
        afterEnter(data) {
          console.log("afterEnter single-to-archive");


          // consideration for back buttons - this could be move into before enter?
          console.log("data.current.url", data.current.url.href);

          updateBackButton(data.next.container, data.current.url.href);
          //ebnd this could be moved into before enter?

          console.log("hello");
          // data.current.container.style.position = 'absolute';
          return tlBarba.to(data.current.container, {
              // opacity: 0,
              x: '100%',
            }, "0")
            // .fromTo(data.next.container, { 
            //   // opacity: 0,
            //   x: '100%',
            // }, {
            //   x: '0%',
            // }, "<")

            // .from(data.next.container, {
            //   // opacity: 0,
            //   x: '100%',
            // }, "<")

            .add(function () {
              console.log("clearTransform(data.next.container) - single-to-archive - error caues?");
              clearTransform(data.next.container) // clear transform rules

            });

        },
        from: {
          namespace: 'single-resources'
        },
        to: {
          namespace: 'archive-resources'
        }
      }, {
        name: 'archive-to-single', // also home?
        sync: false,
        beforeEnter(data) { // archive-to-single
          console.log("beforeEnter archive-to-single");
          // we need to tak ethe old cotainer - and scroll up to the top so that the excerpt post nave is in teh correct postion for when we've loade dthe next page later down
          // observation 0- if coming from the hopme page then go t archive and then single - it stops working - meaning some js vars are causing issues? or timing problems
          // works fine if starting on archive and going to single - so some other js running fomr home to archive is maybe intervening?

          var activePost = body.getAttribute('data-active-post'),
            activeCategory = data.current.container.querySelector("[data-panel-content='resources']").getAttribute('data-category-active'),
            currentActiveCategoryPostDom = data.current.container.querySelector("[data-panel-content='resources']").getAttribute('data-category-active'),
            currentActivePostDom = data.current.container.querySelector('.category__post.post.--active'), // this won't be active untill the below js has run - so we need to wait for that to happen
            currentActiveCategoryDomDescription = data.current.container.querySelector('.category__description'),
            activeHeader = data.current.container.querySelector('.archive__header'),
            activeNav = data.current.container.querySelector('.archive__nav'),
            nonCurrentActivePostDomAbove = getSiblingsAbove(currentActivePostDom),
            nonCurrentActivePostDomBelow = getSiblingsBelow(currentActivePostDom),
            containerType = "post-transform",
            posttransformDom = data.next.container.querySelector('.side-panel__container.--post-transform');

          // console.log("currentActiveCategoryDomDescription", currentActiveCategoryDomDescription);


          if (activePost) { // could it be that this function really slows things down in the transitions?
            // maybe I can add the code into the barba timeline so it doesn't wait for the transition to start
            console.log("IF activePost", activePost);
            filterPostView(activePost, containerType, data.next.container, "archive");
          } else if (activeCategory) {

            filterCategoryView(activeCategory, containerType, data.next.container, "archive"); // review this function -write it
          } else {
            console.log("no activePost - - what else can this be - review and delete if statemenbt else?");
          }


          var posttransformHeader = posttransformDom.querySelector('.panel__header'),
            posttransformNav = posttransformDom.querySelector('.panel__nav'),
            activeCategoryDom = posttransformDom.querySelector('.category.--active[data-resource-category]'),
            activePostDom = activeCategoryDom.querySelector('.category__post.post.--active'), // this won't be active untill the below js has run - so we need to wait for that to happen            
            //post transform dom
            nonActivePostDomAbove = getSiblingsAbove(activePostDom),
            nonActivePostDomBelow = getSiblingsBelow(activePostDom),
            activeCategoryDomDescription = activeCategoryDom.querySelector('.category__description'),
            activePostDomExcerpt = activePostDom.querySelector('.post__excerpt'),
            activePostDomContinueReading = activePostDom.querySelector('a.continue-reading'),
            activePostDomContinueReadingText = activePostDomContinueReading.querySelector('span'),
            offSetValue = ((activePostDom.offsetTop + posttransformNav.offsetTop) * -1),
            postransformNavHeight = posttransformNav.offsetHeight;






          // console.log("activePost", activePost);
          // console.log("activeCategory", activeCategory);
          // console.log("posttransformNav", posttransformNav);
          // console.log("posttransformHeader", posttransformHeader);
          // console.log("activeCategoryDom", activeCategoryDom);

          // console.log("activePost", activePost);
          // console.log("activeCategory", activeCategory);
          // console.log("posttransformNav", posttransformNav);
          // console.log("posttransformHeader", posttransformHeader);
          //   console.log("activePostDom", activePostDom);
          //   console.log("activeCategoryDomDescription", activeCategoryDomDescription);
          // console.log("offSetValue top of post", offSetValue);


          // this is wha thte scrolling distanceToScroll is o the single post... (scrolling from related contenet)
          // relatedDom = data.current.container.querySelector('.single__related');

          // Scroll duration in seconds
          // const urationscrollD = 1; // review

          // Animate the scrollDiv
          // Calculate the distance for the scroll animation

          //this is the distance to scroll to the top of the post for single.
          // const distanceToScroll = relatedDom.scrollHeight - window.innerHeight;
          const distanceToScroll = activeCategoryDom.offsetTop;


          var offSetValue = ((activePostDom.offsetTop + posttransformNav.offsetTop) * -1);
          // var postsoffSetValue = ((activePostDom.offsetTop - posttransformNav.offsetTop - posttransformHeader.offsetTop) * -1);

          var postsoffSetValue = (((activePostDom.offsetTop + postransformNavHeight) * -1));
          // console.log("offSetValue", offSetValue);
          // console.log("activePostDom.offsetTop", activePostDom.offsetTop);
          // console.log("posttransformNav.offsetTop", posttransformNav.offsetTop);
          // console.log("postransformNavHeight", postransformNavHeight);
 



          const moveUp = postsoffSetValue; //offSetValue; //"-100vh";//"-100vh"; - review this - do we also increase the value
          // so adding anotgher 100vh to ensure it goes further (at the same pace - so will look like they move apart)
          const moveDown = "100vh"; //"100vh";




          // console.log("distanceToScroll", distanceToScroll);
          // spacerWidth = 0; //data.current.container.querySelector(".side-panel__spacer").offsetWidth;
          // console.log("spacerWidth - Would just be 0 - as sliding up from bottom?", spacerWidth);
          //height of post excerpt arhvie itme to be transition into the fulll heigh of the post ; so reveal?e
          // or it slides up from the bottom - so we need to know the height of the post excerpt item?
          console.log("beforeenter archive-to-single - tl to start");
          console.log("This is breaking point if coming from previous barba namespaces?");

          //review the ways this animates - on entering a single post we want to slide up from the bottom
          //or something like that 
          return tlBarba
            .add(function () {
              // console.log("moveDown", moveDown);
              // console.log("moveUp", moveUp);

              if (nonCurrentActivePostDomAbove.length > 0) {
                // console.log("nonActivePostDomAbove.length > 0");
                tlBarba.to(nonCurrentActivePostDomAbove, {
                  duration: scrollDuration,
                  y: moveUp,
                }, 0);
                tlBarba.to(nonActivePostDomAbove, { // we can assuem that if current post exist - it will also on the post transrom dom

                  opacity: 0,
                }, 0);
              }
              if (nonCurrentActivePostDomBelow.length > 0) {
                // console.log("nonActivePostDomBelow.length > 0");
                tlBarba.to(nonCurrentActivePostDomBelow, {

                  opacity: 0,
                }, 0);
                tlBarba.to(nonActivePostDomBelow, { // we can assuem that if current post exist - it will also on the post transrom dom
                  opacity: 0,
                }, 0);
              }
            }, "0") // Ensure this runs after the previous animations
            .to(currentActiveCategoryDomDescription, { // not sure this is targeting the correct one - it maybe only targetting the first item !? review above declaation of vars
              opacity: 0,
            }, scrollDuration)
            .to(activePostDomContinueReadingText, {
              width: 0,
              opacity: 0,
            }, scrollDuration)
            .set(data.current.container, {
              position: 'absolute',
              // overflow: 'hidden', // review - this breaks the sticky headers!
              top: 0,
            }, "0")
            .set(data.next.container, {
              position: 'relative',
              // overflow: 'hidden', // review - this breaks the sticky headers!
              opacity: 0,
            }, "0")
            .to(activePostDomContinueReading, {
              columnGap: "0",
            }, scrollDuration)
            .to(activeNav, {
              y: moveUp,
            }, scrollDuration)
            .to(activePostDom, {
              borderBottom: "1px solid transparent",
              borderTop: "1px solid transparent",
            }, scrollDuration)
            .set(posttransformDom, {
              opacity: 1,
              zIndex: 20,
              // background: 'pink',
            }, "0")


        },
        enter(data) { // archive-to-single
          console.log("enter archive-to-single");

          // we need to tak ethe old cotainer - and scroll up to the top so that the excerpt post nave is in teh correct postion for when we've loade dthe next page later down
          var activePost = body.getAttribute('data-active-post');
          // var activeCategory = data.current.container.querySelector("[data-panel-content='resources']").getAttribute('data-category-active'); //
          var activeCategory = body.getAttribute('data-active-category'); // review and tidy up
          var containerType = "post-transform"; // this is being applied on the post transform - on the next container
          var posttransformDom = data.next.container.querySelector('.side-panel__container.--post-transform');
          var posttransformHeader = posttransformDom.querySelector('.panel__header');
          var posttransformNav = posttransformDom.querySelector('.panel__nav');

          var activeCategoryDom = posttransformDom.querySelector('.category.--active[data-resource-category]');
          var activePostDom = activeCategoryDom.querySelector('.category__post.post.--active');
          var nonActivePostDom = activeCategoryDom.querySelectorAll('.category__post.post:not(.--active)');
          // var nonActivePostDomAbove = activeCategoryDom.querySelectorAll('.category__post.post:not(.--active)');
          // var nonActivePostDomBelow = activeCategoryDom.querySelectorAll('.category__post.post:not(.--active)');

          // Example usage: - https://chat.openai.com/c/822c3891-a76d-440d-ba58-fa884878d438
          // const categoryContainer = document.querySelector('.category');
          // const activeItem = categoryContainer.querySelector('.post.--active');

          // const siblingsAbove = getSiblingsAbove(activeItem);
          // const siblingsBelow = getSiblingsBelow(activeItem);

          // console.log("Siblings above:", siblingsAbove);
          // console.log("Siblings below:", siblingsBelow);

          var nonActivePostDomAbove = getSiblingsAbove(activePostDom);
          var nonActivePostDomBelow = getSiblingsBelow(activePostDom);

          // console.log("nonActivePostDomAbove", nonActivePostDomAbove, "REView what happens with last or first item");
          // console.log("nonActivePostDomBelow", nonActivePostDomBelow, "REView what happens with last or first item");


          var postsPanel = posttransformDom.querySelector('.panel__body[data-resource-content="posts"]');
          var activeCategoryDomDescription = activeCategoryDom.querySelector('.category__description');
          var activeContinueReading = activePostDom.querySelector('a.continue-reading');
          var postransformNavHeight = posttransformNav.offsetHeight;

          var offSetValue = ((activePostDom.offsetTop + posttransformNav.offsetTop) * -1);
          // var postsoffSetValue = ((activePostDom.offsetTop - posttransformNav.offsetTop - posttransformHeader.offsetTop) * -1);

          var postsoffSetValue = (((activePostDom.offsetTop + postransformNavHeight) * -1));
          // console.log("offSetValue", offSetValue);
          // console.log("activePostDom.offsetTop", activePostDom.offsetTop);
          // console.log("posttransformNav.offsetTop", posttransformNav.offsetTop);
          // console.log("postransformNavHeight", postransformNavHeight);
 
          // const scrollDuration = 1; // review 


          const moveUp = postsoffSetValue; //offSetValue; //"-100vh";//"-100vh"; - review this - do we also increase the value
          // so adding anotgher 100vh to ensure it goes further (at the same pace - so will look like they move apart)
          const moveDown = "100vh"; //"100vh";


          // console.log("activePost", activePost);
          // console.log("activeCategory", activeCategory);
          // console.log("posttransformNav", posttransformNav);
          // console.log("posttransformHeader", posttransformHeader);
          // console.log("activePostDom", activePostDom);
          // console.log("activeCategoryDom", activeCategoryDom);
          // console.log("activeCategoryDomDescription", activeCategoryDomDescription);
          // console.log(" nonActivePostDom", nonActivePostDom);

          // if (nonActivePostDom.length > 0) {
          //   console.log("THERE ARE NO nonActivePostDom", nonActivePostDom);
          // }



          // Assuming tlBarba is a GSAP timeline instance
          return tlBarba
            .to(data.next.container, {
              opacity: 1,
            }, "0")
            .fromTo(activeCategoryDomDescription, {
              opacity: 1,
            }, {
              opacity: 0,
            }, scrollDuration)
            .fromTo(posttransformNav, {
              opacity: 1,
            }, {
              opacity: 0,
            }, scrollDuration)

            .add(function () {
              console.log("moveDown", moveDown);
              console.log("moveUp", moveUp);

              if (nonActivePostDomAbove.length > 0) {
                // console.log("nonActivePostDomAbove.length > 0");
                tlBarba.to(nonActivePostDomAbove, {

                  duration: scrollDuration,
                  y: moveUp,
                }, 0);
              }

              if (nonActivePostDomBelow.length > 0) {
                // console.log("nonActivePostDomBelow.length > 0");
                tlBarba.to(nonActivePostDomBelow, {

                  duration: scrollDuration,
                  y: moveDown,

                }, 0);
              }
            }, scrollDuration) // Ensure this runs after the previous animations
            .to(activePostDom, {
              y: postsoffSetValue,
              duration: scrollDuration,
            }, scrollDuration)
            .to(window, {
              scrollTo: {
                y: 0,
                autoKill: true,
              },
              duration: scrollDuration,
            }, scrollDuration)

        },
        afterEnter(data) { //archive-to-single
          console.log("afterEnter archive-to-single");
          // consideration for back buttons - this could be move into before enter?
          // console.log("data.current.url", data.current.url.href);
          updateBackButton(data.next.container, data.current.url.href);
          //ebnd this could be moved into before enter?

          return tlBarba.set(data.current.container, {
              // position: 'absolute', //review
              // top: 0, //review
              opacity: 0,
              // x: '-26.6%' // review this exact values - and ensure globally consistent
              // x: (-1 * spacerWidth), // review this exact values - and ensure globally consistent
            }, "<")
            .to(data.next.container, {
              position: 'relative', //review
              // opacity: 1,
              zIndex: 2, //set back to default
            }, "<")
            .add(function () { // review this!
              console.log("clearTransform(data.next.container) - archive-to-single");
              clearTransform(data.next.container) // clear transform rules

            })
        },
        from: {
          namespace: ['archive-resources']
        },
        to: {
          namespace: 'single-resources'
        }
      },
      {
        name: 'single-to-single',
        sync: false,
        beforeEnter(data) { //single-to-single
          console.log("beforeEnter single-to-single");
          // we need to tak ethe old cotainer - and scroll up to the top so that the excerpt post nave is in teh correct postion for when we've loade dthe next page later down
          var activePost = body.getAttribute('data-active-post'),
            // activeCategory = data.current.container.querySelector("[data-panel-content='resources']").getAttribute('data-category-active'),
            // activeNav = data.current.container.querySelector('.single__nav'),

            activeCategory = body.getAttribute('data-active-category'), //review duplicate? in other instances of this barba stuff as well
            containerType = "post-transform",
            posttransformDom = data.next.container.querySelector('.side-panel__container.--post-transform'),
            relatedDom = data.current.container.querySelector('.single__related'); // We can't assume that people are clicking from this; i.e this is not always been interacted with!

          // going from single to single, there may not be an active post - so we need to check for that?
          // console.log("activePost", activePost);
          // console.log("activeCategory", activeCategory);
          // console.log("containerType", containerType);
          // console.log("posttransformDom", posttransformDom);
          // console.log("relatedDom", relatedDom);
          // console.log("Timeline progress:", tlBarba.totalProgress());
          // console.log("Timeline progress; after clearing", tlBarba.totalProgress());

          // if (activePost) {

          //   console.log("IF activePost", activePost);
          //   filterPostView(activePost, containerType, data.next.container, "single");
          // } else if (activeCategory) {

          //   filterCategoryView(activeCategory, containerType, data.next.container, "single"); // review this function -write it
          // } else {
          //   console.log("FINISH THIS CODE! no activePost - - what else can this be - review and delete if statemenbt else?");
          //   // it could be a non actiave post if we are just click back (to a prevoius post) - so we need to check for that as well
          //   // This means I need to do more work on the bloew - split it in the approopriate places - This consists of active and non actives stuff in 1 block of code.... :()
          // }

          // console.log("hello just done the filtering")



          // posttransformHeader = posttransformDom.querySelector('.panel__header'),
          // posttransformNav = posttransformDom.querySelector('.panel__nav'),
          // activeCategoryDom = posttransformDom.querySelector('.category.--active[data-resource-category]'),
          // nonActivePostDom = activeCategoryDom.querySelectorAll('.category__post.post:not(.--active)'),

          // postsPanel = posttransformDom.querySelector('.panel__body[data-resource-content="posts"]'),
          // activeCategoryDomDescription = activeCategoryDom.querySelector('.category__description'),
          // offSetValue = ((activePostDom.offsetTop + posttransformNav.offsetTop) * -1),
          // currentPostDom = relatedDom.querySelector('.category__post.post.--active'), // this won't be active untill the below js has run - so we need to wait for that to happen
          var currentBody = data.current.container.querySelector('.single__body'),
            currentHeader = data.current.container.querySelector('.single__header'),
            relatedHeader = relatedDom.querySelector('.panel__header'),
            relatedHeaderTitle = relatedHeader.querySelector('.panel__header-title'),
            relatedHeaderTitleDiv = relatedHeaderTitle.querySelector('div.dm-serif-display-regular'),





            relatedNav = relatedDom.querySelector('.panel__nav'),
            relatedNavContent = relatedNav.querySelector('.grid'),

            relatedNavHeight = relatedNav.offsetHeight,

            relatedActiveCategoryDom = relatedDom.querySelector('.category.--active[data-resource-category]'),
            activeCategoryDom = relatedDom.querySelector('.category.--active[data-resource-category]'),

            activePostDom = activeCategoryDom.querySelector('.category__post.post.--active'); // this won't be active untill the below js has run - so we need to wait for that to happen


          if (relatedActiveCategoryDom == null) {
            //single to single

            console.log("IF null", relatedActiveCategoryDom);
            // this could be the caase if the user goes back without initialy filtering inthe realated area
            // so just selecte something that - review what happens?! - and change accoridngly
            relatedActiveCategoryDom = relatedDom.querySelector('.category[data-resource-category]'); // some 

            console.log("now not null - but review waht this is:", relatedActiveCategoryDom);

          }

          var relatedActivePostDom = relatedDom.querySelector('.category__post.post.--active'),
            relatedActivePostDomHeader = relatedActivePostDom.querySelector('.post__header'),
            nonActivePostDomAbove = getSiblingsAbove(relatedActivePostDom),
            nonActivePostDomBelow = getSiblingsBelow(relatedActivePostDom),

            relatedActivePostDomExcerptPadding = (relatedNav.offsetHeight / 4), // refer to css ruls for correct measurements

            relatedNonActivePostDom = relatedDom.querySelectorAll('.category__post.post:not(.--active)'),
            relatedNonActivePostDomAbove = getSiblingsAbove(relatedActivePostDom),
            relatedNonActivePostDomBelow = getSiblingsBelow(relatedActivePostDom),
            relatedPostsPanel = relatedDom.querySelector('.panel__body[data-resource-content="posts"]'),
            relatedActiveCategoryDomDescription = relatedActiveCategoryDom.querySelector('.category__description'),
            relatedActiveContinueReading = relatedActivePostDom.querySelector('a.continue-reading'),
            relatedActiveContinueReadingText = relatedActiveContinueReading.querySelector('span'),


            postExpandToggle = relatedActivePostDom.querySelector(".post__link"), // + x icon
            postDate = relatedActivePostDom.querySelector('.post__date'),

            navHeight = relatedActivePostDomHeader.offsetHeight, //relatedHeader.offsetHeight,

            offSetValue = ((relatedActivePostDom.offsetTop) * -1), // this needs dreviewing!?
            postsOffSetValue = (3 * navHeight), //(((relatedActivePostDom.offsetTop + navHeight) * -1));

            // Scroll duration in seconds
            // const scrollDuration = 1; // review - was 0.2 (too fast) - then 1 (too slow)

            // Animate the scrollDiv
            // Calculate the distance for the scroll animation
            // const distanceToScroll = relatedDom.scrollHeight - window.innerHeight;
            // const distanceToScroll = (((relatedDom.offsetTop - ( 3 * navHeight)) * -1));
            // const distanceToScroll = relatedDom.offsetTop - (3 * navHeight) - window.scrollY;
            getScrollOffset =  getComputedStyle(root).getPropertyValue('--header-height'), // the post titles are not header height!
          // distance to scroll - equates to the top of the current active post; ensuring we offest it by the header
            distanceToScroll = relatedActivePostDom.getBoundingClientRect().top + window.scrollY + (- parseInt(getScrollOffset, 10) * 2);//+ 2; // remove px and multiply by 3 (header/nav/title) -- but maybe not always the case?! chekc on mobile


          const moveUp = (distanceToScroll * -1); //"-100vh";//"-100vh";
          const moveDown = "100vh"; //"100vh";

          console.log("relatedDom.offsetTop", relatedDom.offsetTop);
          console.log("navHeight", navHeight);

          console.log("distanceToScroll", distanceToScroll);
          console.log("relatedActivePostDom.offsetTop", relatedActivePostDom.offsetTop);
          console.log("relatedActivePostDom.offsetTop", relatedActivePostDom.offsetTop);
          console.log("postsOffSetValue", postsOffSetValue);

          return tlBarba
          // Label: Setup
          // .timeScale(0.25)

          .add("setup")
          .add(() => {
              relatedHeaderTitleDiv.innerHTML = "Resources";
          }, "setup")
      
          // Label: Collapse Text
          .add("transformReadMoreUI", ">") // Start after setup
          .to(relatedActiveContinueReadingText, { 
              width: 0, 
              opacity: 0 
          }, "transformReadMoreUI")
          .to(relatedActiveContinueReading, { 
              columnGap: "0" 
          }, "transformReadMoreUI")
                    .to(postExpandToggle, { 
              opacity: 0 
          }, "transformReadMoreUI")
          .to(postDate, { 
              marginRight: 0 
          }, "transformReadMoreUI")
          .to(relatedActivePostDom, { 
            borderBottomColor: "transparent", 
            borderTopColor: "transparent" 
           }, "transformReadMoreUI")
      
          // Label: Set Containers
          .add("setContainers", "0") // Start immediately
          .set(data.current.container, { 
              position: 'relative' 
          }, "setContainers")
          .set(data.next.container, { 
              position: 'absolute', 
              top: 0, 
              opacity: 0 
          }, "setContainers")
      
          // Label: Adjust Posts
          .add("adjustPosts", ">") // Start after setContainers
          .add(() => {
              if (relatedNonActivePostDomAbove.length > 0) {
                  console.log("nonActivePostDomAbove.length > 0");
                  tlBarba.to(relatedNonActivePostDomAbove, { 
                      opacity: 0, 
                      y: moveUp 
                  }, "adjustPosts")
              }
              if (relatedNonActivePostDomBelow.length > 0) {
                  console.log("nonActivePostDomBelow.length > 0");
                  tlBarba.to(nonActivePostDomBelow, { 
                      y: moveDown, 
                      opacity: 0 
                  }, "adjustPosts")
              }
              console.log("Adjusting posts!");
          }, "adjustPosts")
      
          // Label: Scrolling
          .add("scrolling", ">") // Start after adjustPosts
          .add(() => {
              console.log("Scrolling to target position...");
              scrollTopPost(relatedActivePostDom);
          }, "scrolling")
      
          // Label: Header Animation
          .add("headerAnimation", ">")
          .to(relatedHeader, { 
              "--pseudo-after-color": "#00000000" 
          }, "headerAnimation")
          .to(relatedActivePostDomHeader, { 
              paddingBottom: relatedActivePostDomExcerptPadding, 
              // backgroundColor: "yellow"
          }, "headerAnimation+=0.1")
          // .to(relatedActivePostDomHeader, { 
          //     "--after-opacity": "1" 
          // }, "headerAnimation+=0.2")
      
          // Label: Navigation Fade
          .add("navFade", ">")
    
          .to(relatedNavContent, { 
              opacity: 0,
              y: -(relatedNavHeight), 
          }, "navFade")
          .to(relatedNav, { 
              backgroundColor: "transparent", 
              opacity: 0,
              height: navHeight// not sure this catesr for the padding etc - or even fucking wordsk1±

          }, "navFade+=0.1")

          // Label: Post Offset
          .add("postOffset", ">")
            .add(() => {
          console.log("postsOffSetValue",postsOffSetValue);
          console.log("navHeight", navHeight);
          })
          
          .to(activePostDom, { 
              y: (-1 * getScrollOffset), 
              //  backgroundColor: "pink"
          }, "postOffset")
            .to(relatedNav, { 
              opacity: 1
          }, "postOffset+=0.1")
          .add(() => {
            console.log("distanceToScroll", distanceToScroll);
            window.scrollTo({
                top: distanceToScroll, 
                behavior: 'smooth'
            });
        }, "postOffset+=0")
          //  .add(function () {
          //   console.log("20sec wating time I thinik we need to ensure the document is scroll to the top");
          // }, "1")
          // // .to(relatedNav, { 
          // //     opacity: 1,
          // //     backgroundColor: "pink"
          // //   }, "navFade+=0.2")
      
          // // Label: Final Scrolling
          // // .add("finalScroll", ">")
          // // .add(() => {
          // //     console.log("Final scroll to related post...");
          // //     window.scrollTo({
          // //         top: distanceToScroll, 
          // //         behavior: 'smooth'
          // //     });
          // // }, "finalScroll")
      
          // // Label: Final Adjustments
          .add("finalAdjustments", ">")

          .to(relatedActiveCategoryDomDescription, { 
              opacity: 0 
          }, "finalAdjustments+=0.2")
        
      
        },
        enter(data) { //single-to-single


          // we;er currently experiencing soem overlapping when the tranisiont start
          // this bbecause ther is qquite a lot scrolling to be done when ints int eh related post area.
          //meaning the reates of scroling distances vs the timing can allow for elements to visually overlap


          console.log("enter single-to-single");
          var activePost = body.getAttribute('data-active-post'),
            activeCategory = data.current.container.querySelector("[data-panel-content='resources']").getAttribute('data-category-active'),
            // activeCategory = body.getAttribute('data-active-category'), //review duplicate? in other instances of this barba stuff as well
            containerType = "post-transform",
            posttransformDom = data.next.container.querySelector('.side-panel__container.--post-transform'),
            relatedDom = data.current.container.querySelector('.single__related'),
            currentBody = data.current.container.querySelector('.single__body'),
            currentHeader = data.current.container.querySelector('.single__header'),
            // posttransformHeader = posttransformDom.querySelector('.panel__header'),
            // posttransformNav = posttransformDom.querySelector('.panel__nav'),
            activeCategoryDom = relatedDom.querySelector('.category.--active[data-resource-category]'),
            activeCategoryDomDescription = activeCategoryDom.querySelector('.category__description'),
            activePostDom = activeCategoryDom.querySelector('.category__post.post.--active'), // this won't be active untill the below js has run - so we need to wait for that to happen
            activePostContinueReading = activePostDom.querySelector('a.continue-reading'),
            nonActivePostDom = activeCategoryDom.querySelectorAll('.category__post.post:not(.--active)'),
            nonActivePostDomAbove = getSiblingsAbove(activePostDom),
            nonActivePostDomBelow = getSiblingsBelow(activePostDom),

            postsPanel = posttransformDom.querySelector('.panel__body[data-resource-content="posts"]'),
            currentPostDom = relatedDom.querySelector('.category__post.post.--active'), // this won't be active untill the below js has run - so we need to wait for that to happen

            relatedHeader = relatedDom.querySelector('.panel__header'),
            relatedNav = relatedDom.querySelector('.panel__nav'),

            relatedActiveCategoryDom = relatedDom.querySelector('.category.--active[data-resource-category]'),
            relatedActivePostDom = relatedDom.querySelector('.category__post.post.--active'),
            relatedNonActivePostDom = relatedDom.querySelectorAll('.category__post.post:not(.--active)'),
            relatedPostsPanel = relatedDom.querySelector('.panel__body[data-resource-content="posts"]'),
            relatedActiveCategoryDomDescription = relatedActiveCategoryDom.querySelector('.category__description'),
            relatedActiveContinueReading = relatedActivePostDom.querySelector('a.continue-reading'),
            navHeight = relatedHeader.offsetHeight,

            // offSetValue = ((relatedActivePostDom.offsetTop)* -1), // this needs dreviewing!?
            postsOffSetValue = (((relatedActivePostDom.offsetTop + navHeight) * -1));
          //   // I think here we don't need to include the nav height:
          //   // we do need to add it - pluse maybe more?
          //   postsoffSetValue = (((relatedActivePostDom.offsetTop + postransformNavHeight) * -1));


          // console.log("postsoffSetValue", postsoffSetValue);
          // console.log("offSetValue", offSetValue);



          // const moveUp = postsoffSetValue; //offSetValue; //"-100vh";//"-100vh"; - review this - do we also increase the value
          // // so adding anotgher 100vh to ensure it goes further (at the same pace - so will look like they move apart)
          // const moveDown = "100vh"; //"100vh";

          // console.log("nonActivePostDom", nonActivePostDom);

          // console.log("offSetValue top of post", offSetValue); // its not quite enough? - does it include the category desciption?
          // console.log("nonActivePostDom", nonActivePostDom);

          // console.log("nonActivePostDomAbove", nonActivePostDomAbove);
          // console.log("nonActivePostDomBelow", nonActivePostDomBelow);
          // console.log("activeCategoryDomDescription", activeCategoryDomDescription);



          return tlBarba
            .to(relatedActiveContinueReading, {
              opacity: "0",
            }, ">")
          // .add(function () {

          //   console.log("enter singl-totsingle here");
          // }, "40")
          //   .to(data.next.container, {
          //     opacity: 1,
          //     // zIndex: 20,
          //   }, "0") // review this timing
          //   // .fromTo(relatedActiveCategoryDomDescription, {
          //   .to(activeCategoryDomDescription, {
          //     opacity: 0,
          //     // backgroundColor: "red",
          //   }, scrollDuration) // review this timing
          //   .fromTo(activePostContinueReading, { // review if correct element ot hiud
          //     opacity: 1,
          //   }, {
          //     opacity: 0,
          //   }, scrollDuration) // review this timing
          //   .fromTo(posttransformHeader, {
          //     opacity: 1,
          //   }, {
          //     opacity: 0,
          //     // backgroundColor: "teal",
          //   }, scrollDuration) // review this timing
          //   .to(posttransformNav, {
          //     opacity: 0,
          //   }, scrollDuration)

          //  .add(function () {
          //  console.log("review whats' happend ngle-to-single enter tlbarba");
          // },"40" )
          //   .to(window, {
          //     scrollTo: {
          //       y: 0,
          //       autoKill: true
          //     },
          //     duration: scrollDuration,
          //     // ease: "power2.out"
          //   }, scrollDuration)
          //   .add(function () {
          //     console.log("moving things")
          //     console.log("moveDown", moveDown);
          //     console.log("moveUp", moveUp);


          //     if (nonActivePostDomAbove.length > 0) {
          //       tlBarba.to(nonActivePostDomAbove, { // look at splitting this into above + below the active post
          //         // background: "green",
          //         duration: scrollDuration,
          //         // y: moveUp,
          //         y: moveUp, // review this - it need to to be overlappibng things during transitions/anmimations
          //         // y: postsoffSetValue,
          //         opacity: 0,
          //         // ease: EaseOption,
          //       }, scrollDuration)

          //     }
          //     if (nonActivePostDomBelow.length > 0) {
          //       tlBarba.to(nonActivePostDomBelow, { // look at splitting this into above + below the active post

          //         duration: scrollDuration,
          //         y: moveDown,
          //         opacity: 0,
          //         // ease: EaseOption, //review
          //       }, scrollDuration)

          //     }
          //   }, scrollDuration)

          // // .to(relatedActivePostDom, {   
          // // .add(function () {
          //   console.log("hello do we get to the end of single-to-single enter tlbarba");
          // })


        },
        afterEnter(data) { //single-to-single
          console.log("afterEnter single-to-single");
          // console.log("data.current.container", data.current.container);
          // console.log("data.next.container", data.next.container);
          // console.log("hello tlBarba", tlBarba);


          // consideration for back buttons - this could be move into before enter?
          // console.log("data.current.url", data.current.url.href);
          // updateBackButton(data.next.container, data.current.url.href); // review
          //ebnd this could be moved into before enter?
          // there is currentluy ablue flash - related post - need to ensure tthat's not there- i.e scroll before visibnle>?

          return tlBarba
            // updateBackButton(data.next.container, data.current.url.href); // review


            .set(window, { //revoew - but I thik we need to hav ethis somwehre - resinstante once we;ve sorted the other scroll isseus
              // currently the timing will be wrong
              scrollTo: {
                y: 0,
                autoKill: true, // review what this does
              },
              duration: 0,
              onComplete: () => {
                console.log("scrolled to top of page?");
                // we need to ensrue certain things have loaded - i.e the js - or ensrue we can't see related content?
              }
            }, "0")
            .to(data.next.container, {
              opacity: 1,
              zIndex: 2,
              // duration: 0.4,
              position: 'relative',
              onComplete: () => {
                console.log("Opacity animation completed!");
                // we need to ensrue certain things have loaded - i.e the js - or ensrue we can't see related content?
              }
            }, ">1") // Aligns with the start of the previous animation
            .add(function () { // review this!
              console.log("clearTransform(data.next.container) - single-to-single");
              clearTransform(data.next.container) // clear transform rules
            })


        },
        from: {
          namespace: 'single-resources'
        },
        to: {
          namespace: 'single-resources'
        }
      }
    ],
    views: [{
        namespace: 'page-about',
        afterEnter(data) { // could be doing this earlier?! - review - this should align or correlate with the scripts running from the namesspace transitions - for example from home, post, category etc.
          // thisi is also after enter - but we never use gsap?!
          console.log("afterEnter: namespace = page-about");
          // could this be causing conflicts with the other afterEnter?


          // console.log("data", data);
          var container = data.next.container; //is the next page
          // $nextcontainer = $(container);
          // remove the data-active-post="" attribute
          body.removeAttribute('data-active-post'); // review this approach + ensure it causes no issues
          body.removeAttribute('data-active-category'); // review this approach + ensure it causes no issues
          // gutenberg blocks
          initBlocks(container); // we can allow this but the js of the references is destoying media item urls (because haver dates in)
          //UI
          initPageAbout(container);
        }
      },
      {
        namespace: 'page',
        afterEnter(data) { // could be doing this earlier?! - review
          // reviewt his for other pages etc - this js the reminanc of the old copy and paste code
          // console.log("afterEnter: namespace = page");
          // console.log("data", data);

          var container = data.next.container, //is the next page
            $nextcontainer = $(container);
          initBlocks(container);
          // console.log("afterEnter: namespace = page - functions loaded")
        }
      },
      {
        namespace: 'error-404',
        afterEnter(data) { // could be doing this earlier?! - review

          console.log("afterEnter: namespace = error-404");
          var container = data.next.container, //is the next page
            $nextcontainer = $(container);
          //need transitions from all pages/namespace to 404 page
          // ensure to forward this to the home page - review best practices to achive this.
        }
      },
      {
        namespace: 'home',
        afterEnter(data) { // could be doing this earlier?! - review

          // console.log("afterEnter: namespace = home");
          var container = data.next.container, //is the next page
            $nextcontainer = $(container);
          //Blocks
          initBlocks(container);
          //UI
          // initHome(container); // this maybe interacting with the initBlocks dom compoentes - so review        
          // console.log("afterEnter: namespace = home - functions loaded")

          // Initialize home UI and store cleanup logic
          cleanupCurrentUI = initHome(container);



        }
      },
      {
        namespace: 'archive-resources',
        afterEnter(data) { // could be doing this earlier?! - review
          // console.log("Enter namespace = archive-resources");

          console.log("afterEnter: namespace = archive-resources");
          var container = data.next.container; //is the next page
          // $nextcontainer = $(container); // not using this...

          // console.log("afterEnter: namespace = archive-resources - functions loaded", $nextcontainer)
          initArchive(container); // this maybe interacting with the initBlocks dom compoentes - so review        

        }
      },
      {
        namespace: 'single-resources',
        afterEnter(data) { // could be doing this earlier?! - review

          console.log("afterEnter: namespace = single-resources");
          console.log("data", data);

          var container = data.next.container; //is the next page
          // $nextcontainer = $(container); // not using this...

          //all gutenberg blocks
          initBlocks(container);

          //UI
          initSingle(container);
          // console.log("afterEnter: namespace = single writting - ALL functions loaded")
        }
      }
    ]
  });

  // console.log("Global hooks", barba.hooks.beforeOnce);


  barba.hooks.beforeLeave((data) => {
    // console.log("GLOBAL -  beforeleave -- add loading class", data);
    body.classList.add("loading");

    //hide bg view
    // console.log("viewerBg - hidden before", viewerBg);
    // I need to review this on a namespace basis - i.e. on home we don't want to hide the bg - but on single we do

    //maybe use z-index or offset if opacity is an issue - as 
    // viewerBg.style.opacity = 0; // but rules differe from home to single - so review this 
    // clear animations:

    // console.log("Timeline progress; before clearing", tlBarba.totalProgress());
    // this defo fucks up other timelines!?
    // clearing the til just before we start tl's = would this not conflict?
    // console.log("Timeline progress;after clearing", tlBarba.totalProgress());
    // now in some instances this freezes>?
    // console.log("finished before Leave global hook")

  }); //barba.hooks.beforeLeave((data) =>

  barba.hooks.afterEnter((data) => {

    console.log("GLOBAL - barba.hooks.after enter", data);
    var nextContainer = data.next.container, //is the next page
      $container = $(nextContainer);


    imageryLoaded($container); //review
    //check on loading progress
    const loaderinterval = setInterval(() => {

      // console.log("loaderinterval")

      if ($("body").hasClass("images-loaded")) {
        // console.log("if has images loaded class");

        // ensure to remove sidepanel class
        // document.documentElement.classList.remove('side-panel-open');
        removePanelClass();

        $("body").removeClass("loading"); //review
        closeNavigation($container);
        //clear interval



        // console.log("viewerBg - show again after , viewerBg);
        viewerBg.style.opacity = 1;


        // ensure doc scrolled to the top - reivew if this works at all times

        // this solves the issues but I think it needs to be integrted in other places; its pretty rought around the ediges now - and maybe causing problems wit hte gsap/namespace animatons
        // this may well be fucking things up; afterEnter is when transitions and animations exist - alter the window would cause issues?

        setTimeout(() => {
          //clear timelines
          // scrollBackToTop(); // this is causing all sorts of issues I think! - 
          // Removed the scroll to top  on - 9th jan' 25 -if we need to ensure a user is at the top of the page - we should do that before ? and/ord check agains other paramantesr to ensure no issues occr!

          // for example - in some instance we are scrolling to content; i.e on resources and also n home
          // console.log("clearing timelines - tlBarba.clear");
          tlBarba.clear(); // review the best place to do this - and/or review its affectivness


          // also if tl is active - how to clear it after and not during?
          // this defo fucks up things!? = also maybe because we clear at the point I maybe even starting ht next 
          // so we need to clear insidesomwhere?


        }, 2000);

        clearInterval(loaderinterval);
      }

    }, 10);


    //review the usage of this:
    //  disableed for now - Try and not use uit!
    // triggerMovement(1, 1); //review usage of this - the aim is to ensure it triggers teh proximitiy script - but it doubt it does atm

    //update intro animation - reivew if afterEnter is wise - i.e classes on body are correct?
    // if (!document.body.classList.contains("home")) {
    //   console.log("is not home update the tl - header opacity and logo ");

    //   updateHeaderStyles("default", document.body); // this is not fuinished- in that when going back ot the home page - the header is still whtie etc.
    //   // my rules are not considering a barba chang eto th home page - so look to alter that in this function - if is home

    // } else{
    //   updateHeaderStyles("home", document.body);
    // }


    // clear timelines here - but after a shor interval - to ensure the page has loaded
    // this is to ensure that the timelines are not conflicting with each other
    // this is to ensure that the timelines are not conflicting with each other


  }); //barba.hooks.afterEnter((data) =>

  barba.hooks.afterLeave((data) => {
    // console.log("GLOBAL -  afterleave");
    // this happens quite early - it means some of my transition work happens afte rthi?!
    // i.e transitions stuff starts at " beforeEnter", "enter" and afterEnter - but this is afterLeave - so it's not in sync with the other transitions


    var nextContainer = data.next.container, //is the next page
      $container = $(nextContainer);

    let updateDeviceClass;
    let updateOrientationClass;

    if (data.next.url.path) {

      const updateItems = $(data.next.html).find('[data-barba-update] li');

      $('[data-barba-update] li').each(function (index) {

        // console.log("for each updated link");

        const newClasses = $(updateItems[index]).get(0).classList.value;
        $(this).attr('class', newClasses);


        // console.log("updateItems");
        // console.log("newClasses", newClasses);

      });

    }


    // use to be stuff like cookies; initial loading scripts etc.
    // chekc if existing touch class
    // console.log("hello current", data.current.html);
    // console.log("document.body.classList", document.body.classList);
    // console.log("document.body.classList contains is-not-touch", document.body.classList.contains("is-not-touch"));
    // console.log("document.body.classList contains is-touch", document.body.classList.contains("is-touch"));


    // TOUCH x MOUSE
    if (document.body.classList.contains("is-not-touch") == true) {
      updateDeviceClass = "is-not-touch";
    } else if (document.body.classList.contains("is-touch") == true) {
      updateDeviceClass = "is-touch";
    } else {
      updateDeviceClass = "";
    }
    // end chekc if existing touch class

    // ORIENTATION

    if (document.body.classList.contains("is-horizontal") == true) {
      updateOrientationClass = "is-horizontal";
      // console.log("updateOrientationClass",updateOrientationClass);

    } else if (document.body.classList.contains("is-vertical") == true) {
      updateOrientationClass = "is-vertical";
      // console.log("updateOrientationClass",updateOrientationClass);

    } else if (document.body.classList.contains("is-square") == true) {
      updateOrientationClass = "is-square";
      // console.log("updateOrientationClass",updateOrientationClass);
    }



    // Get body class from incoming page - native WP ones
    let regexp = /\<body.*\sclass=["'](.+?)["'].*\>/gi,
      match = regexp.exec(data.next.html);
    if (!match || !match[1]) {
      // If no body class, remove it
      document.body.setAttribute("class", "");
      // console.log("no body classes : removing them")

    } else {
      // Set the new body class
      document.body.setAttribute("class", match[1]);
      // console.log("new body classes added");
    }
    // additional svs js framework classes etc
    document.body.classList.add(updateDeviceClass); // apply touch or not class
    document.body.classList.add(updateOrientationClass); // apply is-horizontal, is-vertical or is-square class


  }); //barba.hooks.afterLeave((data) =>

}

export default init